// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-image-detail {
  --footer-height: 55px;
}
wm-image-detail .gallery {
  height: calc(100% - var(--footer-height));
}
wm-image-detail .gallery swiper-slide {
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
}
wm-image-detail .gallery swiper-slide wm-img {
  width: -webkit-fill-available;
  transition: all 1s;
}
wm-image-detail .gallery swiper-slide wm-img img {
  border-radius: 16px;
}
wm-image-detail .gallery swiper-slide .image-name {
  font-size: var(--wm-font-size-base);
  font-weight: 700;
  margin-top: 24px;
  margin-left: 4px;
  color: var(--ion-text-color);
}
wm-image-detail .gallery swiper-slide .image-caption {
  font-size: var(--wm-font-size-sm);
}
wm-image-detail .footer {
  display: flex;
  height: var(--footer-height);
  justify-content: space-between;
  align-items: center;
}
wm-image-detail .footer > * {
  margin: 0 16px;
}
wm-image-detail .footer ion-button {
  width: 32px;
  height: 32px;
  --border-radius: 50%;
  --padding-start: 0;
  --padding-end: 0;
  --box-shadow: none;
  border-radius: 50%;
}
wm-image-detail .footer ion-button.disabled {
  opacity: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/image-detail/image-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;AACE;EACE,yCAAA;AACJ;AAAI;EACE,WAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAEN;AADM;EACE,6BAAA;EACA,kBAAA;AAGR;AAFQ;EACE,mBAAA;AAIV;AADM;EACE,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AAGR;AADM;EACE,iCAAA;AAGR;AAEE;EACE,aAAA;EACA,4BAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;AACI;EACE,cAAA;AACN;AACI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AACN;AAAM;EACE,UAAA;EACA,oBAAA;AAER","sourcesContent":["wm-image-detail {\n  --footer-height: 55px;\n\n  .gallery {\n    height: calc(100% - var(--footer-height));\n    swiper-slide {\n      width: 100%;\n      background-color: white;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 16px;\n      wm-img {\n        width: -webkit-fill-available;\n        transition: all 1s;\n        img {\n          border-radius: 16px;\n        }\n      }\n      .image-name {\n        font-size: var(--wm-font-size-base);\n        font-weight: 700;\n        margin-top: 24px;\n        margin-left: 4px;\n        color: var(--ion-text-color);\n      }\n      .image-caption {\n        font-size: var(--wm-font-size-sm);\n      }\n    }\n  }\n\n  .footer {\n    display: flex;\n    height: var(--footer-height);\n    justify-content: space-between;\n    align-items: center;\n    > * {\n      margin: 0 16px;\n    }\n    ion-button {\n      width: 32px;\n      height: 32px;\n      --border-radius: 50%;\n      --padding-start: 0;\n      --padding-end: 0;\n      --box-shadow: none;\n      border-radius: 50%;\n      &.disabled {\n        opacity: 0;\n        pointer-events: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
